import ComponentIcons from "../../../mixins/ComponentIcons";
import InteractiveElement from "../../../mixins/InteractiveElements";
import ValidationMessage from "../ValidationMessage/ValidationMessage.vue";

export default {
  mixins: [ComponentIcons, InteractiveElement],
  components: {
    ValidationMessage,
  },
  data() {
    if (this.$attrs.value) {
      this.$emit("input", this.$attrs.value, this);
    }
    const setValue = this.value;
    return {
      inputValue: setValue,
      isInput: true,
      isShowingValidationMessage: false,
    };
  },
  props: {
    value: {
      required: false,
    },
    numeric: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultValue() {
      return this.$attrs.value;
    },
  },
  // Enables v-model= on custom components
  watch: {
    value(value) {
      this.inputValue = value;
    },
    inputValue(value) {
      let emitValue = value;
      if (this.numeric === true) emitValue = parseInt(value, 10);
      if (value === "" || value === null) emitValue = null;
      this.$emit("input", emitValue, this);
    },
    isValid() {
      this.$parent.$emit("validChange", this);
    },
  },
  methods: {
    showInvalidMessage() {
      this.isShowingValidationMessage = true;
    },
    scrollTo() {
      this.$el.scrollIntoView();
    },
  },
  mounted() {
    this.$parent.$emit("validChange", this);
  },
  beforeDestroy() {
    this.$parent.$emit("validChange", this, true);
  },
};
